
// api
export const GET_ARCADE_ROOMS = 'API_FETCH__GET_ARCADE_ROOMS';
export const GET_ARCADE_ROOM = 'API_FETCH__GET_ARCADE_ROOM';
export const POST_ARCADE_ROOM = 'API_FETCH__POST_ARCADE_ROOM';
export const PUT_ARCADE_ROOM = 'API_FETCH__PUT_ARCADE_ROOM'; 
export const DELETE_ARCADE_ROOM = 'API_FETCH__DELETE_ARCADE_ROOM';

// section
export const ARCADE_ROOM__CLEAR_ROOM = 'ARCADE_ROOM__CLEAR_ROOM';
export const ARCADE_ROOM__CLEAR_ROOMS = 'ARCADE_ROOM__CLEAR_ROOMS';

// rooms
export const ARCADE_ROOM__SET_ROOMS = 'ARCADE_ROOM__SET_ROOMS';

// room
export const ARCADE_ROOM__SET_ROOM = 'ARCADE_ROOM__SET_ROOM';
export const ARCADE_ROOM__SET_ROOM_CABINETS = 'ARCADE_ROOM__SET_ORDERABLE_CABINETS';
export const ARCADE_ROOM__CLEAR_ROOM_CABINETS = 'ARCADE_ROOM__CLEAR_ROOM_CABINETS';
export const ARCADE_ROOM__SET_REORDERED_CABINETS = 'ARCADE_ROOM__SET_REORDERED_CABINETS';
export const ARCADE_ROOM__ADD_CABINET_TO_ROOM = 'ARCADE_ROOM__ADD_CABINET_TO_ROOM';
export const ARCADE_ROOM__REMOVE_CABINET = 'ARCADE_ROOM__REMOVE_CABINET';
export const ARCADE_ROOM__SET_ROOM_VALUE = 'ARCADE_ROOM__SET_ROOM_VALUE';

